// extracted by mini-css-extract-plugin
export default {"toggle":"HeaderSearchToggle_toggle__aTTBC","toggle_active":"HeaderSearchToggle_toggle_active__J3kGj","icon":"HeaderSearchToggle_icon__+859Z"};